<template lang="pug">
  .zone-list
    div.px-4.pb-4(v-if="deliveryDisabled")
      div.s1.basic800--text {{ $t('delivery_option_disabled') }}
      div.c1.basic600--text {{ $t('delivery_option_disabled_text_1') }}
      div.c1.basic600--text {{ $t('delivery_option_disabled_text_2') }}
    v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
    .content-layout(v-else)
      v-row.fill-height.ma-0(align='center' justify='center' v-if="zones.length == 0")
        div.mx-auto.text-center
          v-img.mx-auto(contain :src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px")
          p.caption {{ $t('no_zones') }}
      template(v-else)
        v-row.grey.lighten-3.py-2(no-gutters)
          v-col.px-4(cols="6" md="8")
            p.text-body-2.mb-0.grey--text.text--darken-1.font-weight-bold {{ $t('shipping_zone') }}
          v-col
            p.text-body-2.mb-0.grey--text.text--darken-1.font-weight-bold {{ $t('activate') }}
        template(v-for="(zone, index) in zones")
          v-row.pt-4(no-gutters)
            v-col.px-4(cols="6" md="8")
              div.s1.basic800-text {{ zone.name }}
              v-layout.pt-1.pb-2
                template(v-for="method in zone.shipping_methods")
                  div.mr-2(v-if="method !== 'pickup'")
                    v-img(contain :src="getMethodIcon(method)" style="width:18px; height:18px")
            v-col.shrink
              y-switch.ma-0.pa-0(v-model="zone.enabled" @change="clickToggleZone(zone)")
            v-col(align="center")
              v-chip.button-AA-tiny(label outlined small color="black" @click="clickEditOption(zone)") {{ $t('manage') }}
          v-divider.mx-0
      y-pagination.ma-4(v-model="page" :pageSize="pageSize" :count="count")

    v-row.mt-3(no-gutters)
      v-col(align="left")
        v-btn.ml-2(color="transparent" x-small text @click="clickAddZone")
          .button-Aa-medium.textColorAccent--text|+ {{ $t('add_zone') }}
    .modals
      update-delivery-zone(v-if="showUpdateOptionDialog" :open.sync="showUpdateOptionDialog" :company="company" :option="editingOption" :couriers="couriers" :allowDelete="zones.length > 1" @added="handleAddItem" @edited="handleEditItem")
      y-dialog(v-model='showDeleteOptionDialog', max-width='290')
        v-card
          v-card-title.title {{ $t('delete_option') }}
          v-card-text
            | {{ $t('delete_option_text') }}
          v-card-actions
            v-spacer
            v-btn(color='grey', text='', @click='showDeleteOptionDialog = false')
              | {{ $t('cancel') }}
            v-btn(color='red', text='', @click='startDelete' :loading="isLoading")
              | {{ $t('delete') }}

</template>

<script>
import { mapActions } from 'vuex'
import UpdateDeliveryZone from '@/components/dialogs/settings/UpdateDeliveryZone.vue'

export default {
  name: 'DeliveryZoneList',
  components: { UpdateDeliveryZone },
  props: ['open', 'company', 'couriers'],
  data: () => ({
    isFetching: true,
    showUpdateOptionDialog: false,
    showDeleteOptionDialog: false,
    editingOption: null,
    deleteOption: null,
    zones: [],
    isLoading: false,
    pageSize: 10,
    page: 1,
    count: 0,
    deliveryDisabled: false
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  watch: {
    page (val) {
      if (!this.isFetching) {
        this.fetchZones(val)
      }
    },
    zones:{
      handler(val){
        this. deliveryDisabled = !val.some(zone=> zone.enabled)
      },
      deep: true
    }
  },
  mounted () {
    this.isFetching = true
    this.fetchZones(1)
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    getMethodIcon (method) {
      if (method == 'manual') {
        return require('@/assets/images/icon_yezza_square.png')
      } else if (method == 'zepto') {
        return require('@/assets/images/icon_zepto.png')
      } else if (method == 'easyparcel') {
        return require('@/assets/images/logo_easyparcel_small.png')
      } else if (method == 'lalamove') {
        return require('@/assets/images/icon_lalamove.png')
      }
      return require('@/assets/images/icon_yezza_v2.png')
    },
    fetchZones (page) {
      this.page = parseInt(page)
      this.isFetching = true
      this.$axios.get(`/shipping/settings/${this.company.slug}/zones?page=${page}&page_size=${this.pageSize}`)
        .then((response) => {
          this.zones = response.data.results
          this.count = response.data.count
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    clickAddZone () {
      this.editingOption = null
      this.showUpdateOptionDialog = true
    },
    clickEditOption (option) {
      this.editingOption = option
      this.showUpdateOptionDialog = true
    },
    clickToggleZone (zone) {
      this.axios.patch(`/shipping/settings/${this.company.slug}/zones/${zone.id}`, {'enabled': zone.enabled})
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    startDelete() {
      this.isLoading  = true
      this.axios.delete(`/shipping/settings/${this.company.slug}/zones/${this.deleteOption.id}`)
        .then(() => {
          this.zones = this.zones.filter((x) => x !== this.deleteOption)
          this.showDeleteOptionDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading  = false
        })
    },
    clickDeleteOption(option) {
      this.showDeleteOptionDialog = true
      this.deleteOption = option
    },
    handleAddItem () {
      this.fetchZones(1)
    },
    handleEditItem (item) {
      for (var i = 0; i < this.zones.length; i++) {
        let option = this.zones[i]
        if (option.id === item.id) {
          this.zones[i] = item
        }
      }
    }
  }
}
</script>

<i18n>
{
  "en": {
    "delivery_option_disabled": "Delivery option is currently disabled",
    "delivery_option_disabled_text_1": "Customer can proceed to payment without providing shipping address.",
    "delivery_option_disabled_text_2": "Activate shiping zone to enable shipping address collection.",
    "no_zones": "No zones added yet",
    "add_zone": "Add Zone",
    "delete_option": "Delete option",
    "delete_option_text": "Are you sure you want to delete this option? This option will be deleted permanently."
  },
  "id": {
    "delivery_option_disabled": "Opsi pengiriman saat ini dinonaktifkan",
    "delivery_option_disabled_text_1": "Pelanggan dapat melanjutkan ke pembayaran tanpa memberikan alamat pengiriman.",
    "delivery_option_disabled_text_2": "Aktifkan zona pengiriman untuk mengaktifkan opsi alamat pengiriman.",
    "no_zones": "Tiada zona yang aktif",
    "add_zone": "Tambah zona",
    "delete_option": "Hapus opsi",
    "delete_option_text": "Anda yakin ingin menghapus opsi ini? Opsi ini akan dihapus secara permanen."
  }
}
</i18n>
